// Fixtures für die INIS-Knotenansicht (#226) — Fixtures-Modus ohne Live-Nexus.
export function inisNodesFixture() {
  const now = new Date().toISOString();
  return {
    nodes: [
      {
        id: 2, hardwareUuid: 'ef11ba22-bbc6-49d0-8f52-2d1c3e631410',
        hwUuid: '9f1c2d34-5e6a-5b7c-8d9e-0a1b2c3d4e5f',
        swUuid: 'c4a92e10-9b48-5221-a4b7-d1982fc9b08f',
        fqdn: '9f1c2d34-5e6a-5b7c-8d9e-0a1b2c3d4e5f.node.valitype.net',
        username: 'nv-8x3k9m2', sshPort: 48122,
        role: 'k3s', targetHostname: 'node07.k3s.valitype.net',
        status: 'assigned', os: 'Linux', arch: 'x86_64', lastSeenAt: now,
      },
      {
        id: 1, hardwareUuid: '7f6d3b08-0e3e-11e6-bc2b-781832821500',
        hwUuid: '2a3b4c5d-6e7f-5a8b-9c0d-1e2f3a4b5c6d',
        swUuid: 'b1d0e2f3-1122-3344-5566-778899aabbcc',
        fqdn: '2a3b4c5d-6e7f-5a8b-9c0d-1e2f3a4b5c6d.node.valitype.net',
        username: 'nv-q7w2e5r', sshPort: 51987,
        role: null, targetHostname: null,
        status: 'pending', os: 'Linux', arch: 'x86_64', lastSeenAt: now,
      },
    ],
  };
}
